import { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface HeaderContextType {
  headerElement: ReactNode | null;
  setHeaderElement: (element: ReactNode | null) => void;
  hideHeader: boolean;
  setHideHeader: (hide: boolean) => void;
}

const HeaderContext = createContext<HeaderContextType | null>(null);

export const HeaderProvider = ({ children }: { children: ReactNode }) => {
  const [headerElement, setHeaderElementState] = useState<ReactNode | null>(null);
  const [hideHeader, setHideHeaderState] = useState(false);
  
  const setHeaderElement = useCallback((element: ReactNode | null) => {
    setHeaderElementState(element);
  }, []);

  const setHideHeader = useCallback((hide: boolean) => {
    setHideHeaderState(hide);
  }, []);

  return (
    <HeaderContext.Provider value={{ 
      headerElement, 
      setHeaderElement,
      hideHeader,
      setHideHeader,
    }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeaderContext must be used within HeaderProvider');
  }
  return context;
};
